import type { AllValues } from '@/utils/types/types.util';
import type { Permission, PermissionName } from './permission.types';
import { type CorePermissions } from './permissions';

export function hasCorePermission(
  chosenPermission: AllValues<typeof CorePermissions>,
  corePermissions: AllValues<typeof CorePermissions>[],
) {
  return corePermissions.includes(chosenPermission);
}

export function hasUserPermission(
  chosenPermission: PermissionName,
  userPermissions: Permission[],
): boolean {
  const permission = userPermissions.find((p) => p.permission_name === chosenPermission);
  if (!permission) {
    return false;
  }
  return permission.active && permission.state === 'assigned';
}

export function permissionIsNotSet(
  chosenPermission: PermissionName,
  userPermissions: Permission[],
) {
  const permission = userPermissions.find((p) => p.permission_name === chosenPermission);
  if (!permission) {
    return false;
  }
  return permission.state === 'not-set';
}
